var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(option,key){return _c('label',{key:key},[_c('input',{attrs:{"type":"radio"},domProps:{"value":option,"checked":option === _vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v("\n    "+_vm._s(option)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }